module.exports = __webpack_public_path__ + "img/1560260029.a638d65b.jpg";